/**
 * El DOM tolera a quien lo toca por fuera de React (#116, 16-oct-2026).
 *
 * El traductor de Chrome y algunas extensiones (traductores, correctores, «modo oscuro») reemplazan los nodos de texto
 * de la página por otros propios. Cuando React después quiere quitar o reordenar ESE texto, el navegador tira
 * «Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node» (o lo mismo con
 * `insertBefore`) y, sin esto, toda la pantalla se caía. Medido el primer día del registro de errores: 20 veces en 2
 * personas de la oficina y 3 en un chofer, en Despacho, Flota en Vivo y la app del chofer.
 *
 * Lo que hace: si el hijo que React quiere quitar ya no es hijo de ese nodo, no hace nada; si el «antes de» ya no es
 * hijo, agrega al final. Es el remedio conocido (React no lo trae de fábrica a propósito). Cada caso se cuenta una vez
 * por pestaña con `avisar`, así se sigue viendo en el Monitor sin romper nada. Lo PURO está en `parchar(proto, avisar)`.
 */

export const MENSAJE = "El navegador modificó la página por fuera de la app (traductor o extensión): se toleró";

export function parchar(proto, avisar = () => {}) {
  if (!proto || proto.__qbTolerante) return () => {};
  const removeChild = proto.removeChild;
  const insertBefore = proto.insertBefore;
  let avisado = false;
  const contar = (que) => {
    if (avisado) return;
    avisado = true;
    try { avisar(que); } catch { /* avisar nunca rompe */ }
  };
  proto.removeChild = function (child) {
    if (child && child.parentNode !== this) {
      contar("removeChild");
      return child;
    }
    return removeChild.call(this, child);
  };
  proto.insertBefore = function (nuevo, antes) {
    if (antes && antes.parentNode !== this) {
      contar("insertBefore");
      return proto.appendChild.call(this, nuevo);
    }
    return insertBefore.call(this, nuevo, antes);
  };
  proto.__qbTolerante = true;
  return () => {
    proto.removeChild = removeChild;
    proto.insertBefore = insertBefore;
    proto.__qbTolerante = false;
  };
}

/** Se instala una vez al arrancar, antes de dibujar nada. `avisar` manda el caso al registro de errores. */
export function instalarDomTolerante(avisar) {
  if (typeof Node === "undefined") return () => {};
  return parchar(Node.prototype, avisar);
}
